import React, { forwardRef } from 'react';
import cn from 'classnames';
import SvgIcon from '../../../common/SvgIcon';
import Button from "../../../common/components/Button/Button";

const BriefWelcome = (
  { value, invalid, proPlatform, className, onChange, children, onNext },
  ref,
) => (
  <div ref={ref} className={cn('brief_welcome', className)}>
    <div className="brief_welcome-content">
      <h2 className="brief_welcome-title">
        How exciting!
      </h2>
      <div className="brief_welcome-text">
        <p className="-bigger">
          You are just a few short steps away from starting the process to bring your design dreams to life.
        </p>
        <p className="-bigger">
          Simply click below to get started and choose your rooms.
        </p>
      </div>
      <div className="brief_welcome-button">
        <Button className={cn("btn -gold -brief -welcome")} onClick={onNext}>Get started</Button>
      </div>
    </div>
  </div>
);

export default forwardRef(BriefWelcome);



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefWelcome.js